
import { toString as toString_1, Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, int32_type, list_type, bool_type, option_type, anonRecord_type, class_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ToolConfirmReminderDto, ToolConfirmReminderDto_$reflection, ToolReminderUpdateResult_$reflection } from "../../../Shared/Tool.js";
import { FormState__startLoading, FormState_get_empty, ReminderDateDto_$reflection, FormState_$reflection, ToolId_$reflection, EmptyResponse_$reflection, ClientApiResponse$1_$reflection, PostResponse$1_$reflection } from "../../../Shared/Shared.js";
import { DTO_InspectionTemplateDetailDto_$reflection } from "../../../Shared/InspectionTemplate.js";
import { FileEntry, FileEntry_$reflection } from "./Types.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch, Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton as singleton_1, length, tryFind, contains, exists, filter, indexed, choose, map, append, tail as tail_1, head as head_1, isEmpty, empty, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrapToolId } from "../../../Shared/Helper.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { DTO_WriteInspectionResultDto, InspectionResultStatus, DTO_WriteInspectionResultDto_$reflection } from "../../../Shared/InspectionResult.js";
import { ensureRequestBodySize } from "../../../ErrorHandling.js";
import { Cmd_errorToast, Cmd_successToast } from "../../../Components/Toast.js";
import { now as now_1, addDays, addYears, addMonths } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { unwrap, bind, defaultArg, map as map_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toISOString } from "../../../Common.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { createObj, stringHash } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Dialog } from "../../../Components/Dialog.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map as map_2, empty as empty_1, singleton, append as append_1, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { SelectWithColor, Select } from "../../../Components/Select.js";
import { DatePicker } from "../../../Components/DatePicker.js";
import { TextArea } from "../../../Components/TextArea.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { InformationAlert } from "../../../Components/Alert.js";
import { rangeDouble } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { TextButton } from "../../../Components/Button.js";
import { Input } from "../../../Components/Input.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSelectedTemplate", "SetInspectionDate", "SetSelectedResult", "SetInspectionComment", "SetCreateNewDate", "SetNextInspectionDate", "AddFiles", "RemoveFile", "SetFileName", "SetFileDescription", "SetIsVisibleForUserRole", "Submit", "ReminderConfirmed", "InspectionResultCreated", "FileUploaded", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.Tool.Details.InspectionFromReminderDialog.Msg", [], Msg, () => [[["Item", option_type(anonRecord_type(["label", string_type], ["value", class_type("System.Guid")]))]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", option_type(anonRecord_type(["color", string_type], ["label", string_type], ["value", string_type]))]], [["Item", string_type]], [["Item", bool_type]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", list_type(class_type("Browser.Types.File", undefined))]], [["Item", int32_type]], [["Item1", int32_type], ["Item2", string_type]], [["Item1", int32_type], ["Item2", string_type]], [["Item", bool_type]], [], [["Item", ClientApiResponse$1_$reflection(PostResponse$1_$reflection(ToolReminderUpdateResult_$reflection()))]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", ClientApiResponse$1_$reflection(PostResponse$1_$reflection(EmptyResponse_$reflection()))]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(ToolId, FormState, SuccessCallback, OnClose, Reminder, InspectionTemplates, ToolCategoryIds, SelectedTemplate, InspectionDate, SelectedResult, InspectionComment, CreateNewDate, NextInspectionDate, FileEntries, PendingUploads, IsVisibleForUserRole, InspectionResultId) {
        super();
        this.ToolId = ToolId;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Reminder = Reminder;
        this.InspectionTemplates = InspectionTemplates;
        this.ToolCategoryIds = ToolCategoryIds;
        this.SelectedTemplate = SelectedTemplate;
        this.InspectionDate = InspectionDate;
        this.SelectedResult = SelectedResult;
        this.InspectionComment = InspectionComment;
        this.CreateNewDate = CreateNewDate;
        this.NextInspectionDate = NextInspectionDate;
        this.FileEntries = FileEntries;
        this.PendingUploads = PendingUploads;
        this.IsVisibleForUserRole = IsVisibleForUserRole;
        this.InspectionResultId = InspectionResultId;
    }
}

function State_$reflection() {
    return record_type("Tools.Tool.Details.InspectionFromReminderDialog.State", [], State, () => [["ToolId", ToolId_$reflection()], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Reminder", ReminderDateDto_$reflection()], ["InspectionTemplates", list_type(DTO_InspectionTemplateDetailDto_$reflection())], ["ToolCategoryIds", list_type(string_type)], ["SelectedTemplate", option_type(anonRecord_type(["label", string_type], ["value", class_type("System.Guid")]))], ["InspectionDate", option_type(class_type("System.DateTime"))], ["SelectedResult", option_type(anonRecord_type(["color", string_type], ["label", string_type], ["value", string_type]))], ["InspectionComment", string_type], ["CreateNewDate", bool_type], ["NextInspectionDate", option_type(class_type("System.DateTime"))], ["FileEntries", list_type(FileEntry_$reflection())], ["PendingUploads", list_type(FileEntry_$reflection())], ["IsVisibleForUserRole", bool_type], ["InspectionResultId", option_type(string_type)]]);
}

function confirmReminderCmd(toolId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(ToolReminderUpdateResult_$reflection())));
        }, refreshOn)))(true);
    })), [concat("/api/tools/", unwrapToolId(toolId), ..."/reminder/confirm"), toString(0, Auto_generateBoxedEncoder_437914C6(ToolConfirmReminderDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Msg(12, [Item])), (Item_1) => (new Msg(15, [Item_1])));
}

function createInspectionResultCmd(toolId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/inspection-results/tools/", ...unwrapToolId(toolId)), toString(0, Auto_generateBoxedEncoder_437914C6(DTO_WriteInspectionResultDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Msg(13, [Item])), (Item_1) => (new Msg(15, [Item_1])));
}

function uploadFileCmd(toolId, reminderId, inspectionResultId, isVisibleForUserRole, entry) {
    const toolId_1 = unwrapToolId(toolId);
    const formData = new FormData();
    formData.append(entry.File.name, entry.File);
    formData.append("Name", entry.Name);
    formData.append("Description", entry.Description);
    formData.append("IsVisibleForUserRole", toString_1(isVisibleForUserRole));
    formData.append("ReminderId", reminderId);
    formData.append("InspectionResultId", inspectionResultId);
    return Cmd_OfPromise_either((tupledArg) => {
        const formData_2 = tupledArg[1];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_3;
            ensureRequestBodySize(formData_2);
            return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(EmptyResponse_$reflection())));
            }, refreshOn)))(true);
        }));
    }, [concat("/api/tools/", toolId_1, ..."/files"), formData], (Item) => (new Msg(14, [Item])), (Item_1) => (new Msg(15, [Item_1])));
}

function uploadNextOrFinish(state) {
    const matchValue = state.PendingUploads;
    const matchValue_1 = state.InspectionResultId;
    let matchResult, head, irId, tail;
    if (!isEmpty(matchValue)) {
        if (matchValue_1 != null) {
            matchResult = 0;
            head = head_1(matchValue);
            irId = matchValue_1;
            tail = tail_1(matchValue);
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, tail, state.IsVisibleForUserRole, state.InspectionResultId), uploadFileCmd(state.ToolId, state.Reminder.Id, irId, state.IsVisibleForUserRole, head)];
        default:
            return [new State(state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, empty(), state.IsVisibleForUserRole, undefined), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                state.SuccessCallback();
            }), Cmd_ofEffect((_arg_1) => {
                state.OnClose();
            }), Cmd_successToast("inspection_result.created_successfully")]))];
    }
}

function calcNextInspectionDate(reminder) {
    let matchValue_1, customInterval, matchValue_2;
    const now = reminder.Date;
    const matchValue = reminder.Interval;
    if (matchValue == null) {
        return undefined;
    }
    else {
        const interval = matchValue;
        return (interval.tag === 1) ? addMonths(now, 1) : ((interval.tag === 2) ? addMonths(now, 3) : ((interval.tag === 3) ? addMonths(now, 6) : ((interval.tag === 4) ? addYears(now, 1) : ((interval.tag === 5) ? addYears(now, 2) : ((interval.tag === 6) ? ((matchValue_1 = reminder.CustomInterval, (matchValue_1 == null) ? addDays(now, 0) : ((customInterval = matchValue_1, (matchValue_2 = customInterval.Interval, (matchValue_2 === "month") ? addMonths(now, customInterval.Value) : ((matchValue_2 === "week") ? addDays(now, customInterval.Value * 7) : ((matchValue_2 === "year") ? addYears(now, customInterval.Value) : addDays(now, customInterval.Value)))))))) : addDays(now, 7))))));
    }
}

function init(toolId, successCallback, reminder, onClose, inspectionTemplates, toolCategoryIds) {
    return [new State(toolId, FormState_get_empty(), successCallback, onClose, reminder, inspectionTemplates, toolCategoryIds, undefined, now_1(), undefined, "", reminder.Interval != null, calcNextInspectionDate(reminder), empty(), empty(), false, undefined), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, msg.fields[0], state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 2:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, msg.fields[0], state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 3:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, msg.fields[0], state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 4:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, msg.fields[0], state.NextInspectionDate, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 5:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, msg.fields[0], state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 6:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, append(state.FileEntries, map((f) => (new FileEntry(f, "", "")), msg.fields[0])), state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 7:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, choose((tupledArg) => {
                if (tupledArg[0] !== msg.fields[0]) {
                    return tupledArg[1];
                }
                else {
                    return undefined;
                }
            }, indexed(state.FileEntries)), state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 8:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, map((tupledArg_1) => {
                const e_1 = tupledArg_1[1];
                if (tupledArg_1[0] === msg.fields[0]) {
                    return new FileEntry(e_1.File, msg.fields[1], e_1.Description);
                }
                else {
                    return e_1;
                }
            }, indexed(state.FileEntries)), state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 9:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, map((tupledArg_2) => {
                const e_2 = tupledArg_2[1];
                if (tupledArg_2[0] === msg.fields[0]) {
                    return new FileEntry(e_2.File, e_2.Name, msg.fields[1]);
                }
                else {
                    return e_2;
                }
            }, indexed(state.FileEntries)), state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 10:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.PendingUploads, msg.fields[0], state.InspectionResultId), Cmd_none()];
        case 11: {
            const confirmDto = new ToolConfirmReminderDto(true, state.Reminder.Id, state.CreateNewDate && (state.Reminder.Interval != null), false, undefined, (state.CreateNewDate && (state.Reminder.Interval != null)) ? map_1(toISOString, state.NextInspectionDate) : undefined, "", undefined);
            return [new State(state.ToolId, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), confirmReminderCmd(state.ToolId, confirmDto)];
        }
        case 12:
            if (msg.fields[0].tag === 0) {
                const matchValue_1 = state.SelectedTemplate;
                const matchValue_2 = state.InspectionDate;
                const matchValue_3 = state.SelectedResult;
                let matchResult, date, result, tmpl;
                if (matchValue_1 != null) {
                    if (matchValue_2 != null) {
                        if (matchValue_3 != null) {
                            matchResult = 0;
                            date = matchValue_2;
                            result = matchValue_3;
                            tmpl = matchValue_1;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return [state, createInspectionResultCmd(state.ToolId, new DTO_WriteInspectionResultDto(tmpl.value, date, result.value, (result.color === "#22c55e") ? (new InspectionResultStatus(0, [])) : (new InspectionResultStatus(1, [])), state.InspectionComment, empty(), state.Reminder.Id))];
                    default:
                        return [new State(state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                            state.SuccessCallback();
                        }), Cmd_ofEffect((_arg_1) => {
                            state.OnClose();
                        }), Cmd_successToast("tool.dialog_mark_appointment_as_done_success")]))];
                }
            }
            else {
                return [new State(state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_errorToast("validation.toast")];
            }
        case 13:
            if (msg.fields[0].tag === 1) {
                return [new State(state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_errorToast("validation.toast")];
            }
            else {
                return uploadNextOrFinish(new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.FileEntries, state.IsVisibleForUserRole, msg.fields[0].fields[0]));
            }
        case 14:
            if (msg.fields[0].tag === 1) {
                return [new State(state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, empty(), state.IsVisibleForUserRole, state.InspectionResultId), Cmd_errorToast("validation.toast")];
            }
            else {
                return uploadNextOrFinish(state);
            }
        case 15:
            return [new State(state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_errorToast("validation.toast")];
        default:
            return [new State(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.Reminder, state.InspectionTemplates, state.ToolCategoryIds, msg.fields[0], state.InspectionDate, undefined, state.InspectionComment, state.CreateNewDate, state.NextInspectionDate, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
    }
}

export function OpenDialog(props) {
    let Title, elems_11;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.ToolId, props.SuccessCallback, props.Reminder, props.OnClose, props.InspectionTemplates, props.ToolCategoryIds), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const formState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const isRecurring = state_1.Reminder.Interval != null;
    const availableTemplates = filter((tmpl) => exists((catId) => contains(catId, state_1.ToolCategoryIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), tmpl.CategoryIds), state_1.InspectionTemplates);
    const templateOptions = map((tmpl_1) => ({
        label: tmpl_1.Name,
        value: tmpl_1.Id,
    }), availableTemplates);
    const resultOptions = defaultArg(map_1((t_2) => append(map((r) => ({
        color: "#22c55e",
        label: r,
        value: r,
    }), t_2.SuccessfulResults), map((r_1) => ({
        color: "#ef4444",
        label: r_1,
        value: r_1,
    }), t_2.FailedResults)), bind((opt) => tryFind((t_1) => (t_1.Id === opt.value), availableTemplates), state_1.SelectedTemplate)), empty());
    const canSubmit = (((state_1.SelectedTemplate != null) && (state_1.InspectionDate != null)) && (state_1.SelectedResult != null)) && !state_1.FormState.IsLoading;
    return createElement(Dialog, (Title = t("reminder_dialog.create_inspection"), {
        Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_11 = toList(delay(() => append_1(singleton(createElement(Select, {
            ComponentState: formState,
            IsClearable: true,
            Label: t("inspection_result.template"),
            NoOptionsMessage: "general.no_options",
            OnChange: (opt_1) => {
                dispatch(new Msg(0, [opt_1]));
            },
            Options: templateOptions,
            PlaceholderKey: "inspection_result.template_placeholder",
            TestId: "inspection-from-reminder-template-select",
            Value: unwrap(state_1.SelectedTemplate),
        })), delay(() => append_1(singleton(createElement(DatePicker, {
            ComponentState: formState,
            IsClearable: false,
            Label: t("inspection_result.date"),
            OnChange: (newDate) => {
                dispatch(new Msg(1, [newDate]));
            },
            TestId: "inspection-from-reminder-date-picker",
            Value: unwrap(state_1.InspectionDate),
        })), delay(() => append_1((length(resultOptions) > 0) ? singleton(createElement(SelectWithColor, {
            ComponentState: formState,
            IsClearable: true,
            Label: t("inspection_result.result"),
            NoOptionsMessage: "general.no_options",
            OnChange: (opt_2) => {
                dispatch(new Msg(2, [opt_2]));
            },
            Options: resultOptions,
            PlaceholderKey: "inspection_result.result_placeholder",
            TestId: "inspection-from-reminder-result-select",
            Value: unwrap(state_1.SelectedResult),
        })) : empty_1(), delay(() => append_1(singleton(createElement(TextArea, {
            ComponentState: formState,
            Label: t("inspection_result.comment"),
            OnChange: (value_3) => {
                dispatch(new Msg(3, [value_3]));
            },
            TestId: "inspection-from-reminder-comment",
            Value: state_1.InspectionComment,
        })), delay(() => append_1(isRecurring ? append_1(singleton(Checkbox({
            ComponentState: formState,
            IsChecked: state_1.CreateNewDate,
            Label: t("reminder_dialog.plan_next_date"),
            OnCheck: (value_4) => {
                dispatch(new Msg(4, [value_4]));
            },
            TestId: "inspection-from-reminder-create-new-date",
        })), delay(() => append_1(singleton(createElement(InformationAlert, {
            Label: t("reminder_dialog.create_new_reminder_info"),
        })), delay(() => (state_1.CreateNewDate ? singleton(createElement(DatePicker, {
            ComponentState: formState,
            IsClearable: true,
            Label: t("tool.next_inspection"),
            OnChange: (newDate_1) => {
                dispatch(new Msg(5, [newDate_1]));
            },
            TestId: "inspection-from-reminder-next-date",
            Value: unwrap(state_1.NextInspectionDate),
        })) : empty_1()))))) : empty_1(), delay(() => {
            let elems_10;
            return singleton(reactElement("div", createObj(singleton_1((elems_10 = toList(delay(() => append_1(singleton(reactElement("label", {
                className: join(" ", ["text-sm", "font-bold", "mb-2", "block"]),
                children: t("inspection_result.document_upload"),
            })), delay(() => {
                let elems_1, elems;
                return append_1(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "justify-center", "items-center", "mt-4", "mb-4", "rounded-lg", "border", "border-dashed", "border-primary", "p-4"])], ["onDragOver", (e) => {
                    e.preventDefault();
                }], ["onDrop", (e_1) => {
                    e_1.preventDefault();
                    dispatch(new Msg(6, [toList(delay(() => map_2((i) => e_1.dataTransfer.files.item(i), rangeDouble(0, 1, e_1.dataTransfer.files.length - 1))))]));
                }], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "mb-4"])], (elems = [createElement(TextButton, {
                    ComponentState: formState,
                    Label: t("file_upload.select_file"),
                    OnClick: () => {
                        const element = document.getElementById("reminder-inspection-file-upload");
                        element.click();
                    },
                    TestId: "reminder-inspection-file-upload-btn",
                    Variant: "blueButton",
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let elems_2;
                    return append_1(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-center"])], (elems_2 = [reactElement("input", {
                        id: "reminder-inspection-file-upload",
                        className: join(" ", ["hidden"]),
                        type: "file",
                        multiple: true,
                        onChange: (ev) => {
                            const fileList = ev.target.files;
                            if (!(fileList == null)) {
                                dispatch(new Msg(6, [toList(delay(() => map_2((i_1) => fileList.item(i_1), rangeDouble(0, 1, fileList.length - 1))))]));
                            }
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                        let elems_8;
                        return append_1(!isEmpty(state_1.FileEntries) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "mt-2"])], (elems_8 = toList(delay(() => map((tupledArg) => {
                            let elems_7, elems_5, elems_3, elems_4, elems_6;
                            const index = tupledArg[0] | 0;
                            const entry = tupledArg[1];
                            return reactElement("div", createObj(ofArray([["className", join(" ", ["rounded-md", "border", "border-border", "p-3"])], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "mb-2"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "min-w-0"])], (elems_3 = [reactElement("span", {
                                className: join(" ", ["text-sm", "truncate", "font-medium"]),
                                children: entry.File.name,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("button", createObj(ofArray([["className", join(" ", ["text-gray-400", "hover:text-red-500", "flex-shrink-0", "ml-2", "cursor-pointer"])], ["disabled", "disabled" === formState], ["onClick", (e_2) => {
                                e_2.preventDefault();
                                e_2.stopPropagation();
                                dispatch(new Msg(7, [index]));
                            }], (elems_4 = [reactElement("span", {
                                children: "✕",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_6 = [createElement(Input, {
                                ComponentState: formState,
                                Label: t("general.name"),
                                OnChange: (v) => {
                                    dispatch(new Msg(8, [index, v]));
                                },
                                TestId: `reminder-inspection-doc-name-${index}`,
                                Value: entry.Name,
                            }), createElement(Input, {
                                ComponentState: formState,
                                Label: t("general.description"),
                                OnChange: (v_1) => {
                                    dispatch(new Msg(9, [index, v_1]));
                                },
                                TestId: `reminder-inspection-doc-description-${index}`,
                                Value: entry.Description,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
                        }, indexed(state_1.FileEntries)))), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty_1(), delay(() => {
                            let elems_9;
                            return !isEmpty(state_1.FileEntries) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2", "mt-2"])], (elems_9 = [Checkbox({
                                ComponentState: formState,
                                IsChecked: state_1.IsVisibleForUserRole,
                                Label: t("tool.document_visible_for_user_role"),
                                OnCheck: (value_45) => {
                                    dispatch(new Msg(10, [value_45]));
                                },
                                TestId: "reminder-inspection-doc-visible-for-user-role",
                            }), createElement(InformationAlert, {
                                Label: t("tool.document_visible_for_user_role_upload_info"),
                            })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty_1();
                        }));
                    }));
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_10))])))));
        })))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_11))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: formState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "cancel-inspection-from-reminder",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: canSubmit ? "enabled" : "disabled",
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(11, []));
            },
            TestId: "save-inspection-from-reminder",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

